import {WebFormModel} from "capitalist-shared/src/core/model";
import axios from "axios";
import {CurrencyCode} from "@/models/core/currency";

export enum TxSearchResultStatusEnum {
  Found = 'found',
  NotFound = 'notfound',
  Executed = 'executed',
  Planned = 'planned'
}

export interface TxSearchResult extends Record<any, any> {
  state: TxSearchResultStatusEnum
  currency: CurrencyCode
  tx: string | null
}



export class TxSearchModel extends WebFormModel {

  search(tx: string) {
    return axios.post('/webapi/finance/cryptotx/findTx', {tx: tx}, {
      timeout: 3000
    }).then(result => {
      return {...result.data?.txresult } as TxSearchResult;
    });
  }

}
